import React, { useEffect, useState } from "react";
import "./createEvent.scss";

import DeleteIcon from "@mui/icons-material/Delete";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

import VoidSpace from "../../components/voidSpace/VoidSpace";
import HeaderBar from "../../components/headerBar/HeaderBar";
import ListTopic from "../../components/listTopic/ListTopic";
import ListEventType from "../../components/listEventType/ListEventType";
import ColorPicker from "../../components/colorPicker/ColorPicker";

import moment from "moment/moment";
import { t } from "i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { setGlobalState } from "../../utils/state";
import { gestioneSnackbar } from "../../utils/common";
import { colors } from "../../enums/colors";
import { Button, Form, Modal, Stack } from "react-bootstrap";
import {
  getAllTopicWS,
  getDetailsEventWS,
  getEventTypeWS,
  postEventWS,
  putEventWS,
} from "./api/createEventApi";
import {
  daProvinciaASigla,
  daSiglaAProvincia,
  province,
} from "../../enums/province";
import { base64ToBlob, isEmpty } from "../../utils/validation";

const CreateEvent = () => {
  const navigate = useNavigate();
  const { id_association } = useParams();

  const giorniSettimana = t("calendar.days", {
    returnObjects: true,
  });

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [showModalShift, setShowModalShift] = useState(false);
  const [showModalRepetition, setShowModalRepetition] = useState(false);

  const [idEvent, setIdEvent] = useState(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [indirizzo, setIndirizzo] = useState("");
  const [comune, setComune] = useState("");
  const [provincia, setProvincia] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [publicEvent, setPublicEvent] = useState(false);
  const [thereAreShifts, setThereAreShifts] = useState(false);
  const [thereAreRepetition, setThereAreRepetition] = useState(false);
  const [shift, setShift] = useState([
    {
      id: 0,
      id_shift: 0,
      title: "Turno 1",
      description: "",
      color: colors[0],
      start_datetime: "",
      end_datetime: "",
      max_volunteer: 1,
      open_subscription: 0,
    },
  ]);

  const [selectedDayRepetition, setSelectedDayRepetition] = useState([]);
  const [listTopic, setListTopic] = useState([]);
  const [topic, setTopic] = useState([]);
  const [listEventType, setListEventType] = useState([]);
  const [eventType, setEventType] = useState([]);

  const [images, setImages] = useState([]);
  const [files, setFiles] = useState([]);

  const loadEventsInformations = () => {
    if (!isEmpty(idEvent)) {
      getDetailsEventWS({ id: idEvent })
        .then((res) => {
          setName(res.name);
          setDescription(res.description);
          const address = res.address.split(", ");
          setIndirizzo(address[0]);
          setComune(address[1]);
          setProvincia(daSiglaAProvincia[address[2]]);
          setStartDate(
            moment(res.start_date, "DD/MM/YYYY HH:mm").format(
              "YYYY-MM-DD HH:mm"
            )
          );
          console.log(startDate);
          setEndDate(
            moment(res.end_date, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD HH:mm")
          );
          setPublicEvent(!!res.public);

          if (res.shift.length > 0) setThereAreShifts(true);
          else setThereAreShifts(false);

          setShift(
            res.shift.map((item, index) => ({
              id: index,
              color: item.color,
              title: isEmpty(item.title) ? "Turno " + (index + 1) : item.title,
              description: item.description,
              max_volunteer: item.max_volunteer,
              id_shift: item.id,
              open_subscription: item.open_subscription,
              start_datetime: moment(
                item.start_datetime,
                "DD/MM/YYYY HH:mm"
              ).format("YYYY-MM-DD HH:mm:ss"),
              end_datetime: moment(
                item.end_datetime,
                "DD/MM/YYYY HH:mm"
              ).format("YYYY-MM-DD HH:mm:ss"),
            }))
          );
          setTopic(res.topic.map((item) => item.id));
          setEventType(res.event_type.map((item) => item.id));
          setImages(
            res.photo.map((item) =>
              item.image
                ? "data:" + item.image_type + ";base64," + item.image
                : "/no_img.png"
            )
          );
        })
        .catch((err) => console.error(err));
    }

    getAllTopicWS()
      .then((res) => setListTopic(res))
      .catch((err) => console.error(err));

    getEventTypeWS()
      .then((res) => setListEventType(res))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 2);

    setIdEvent(queryParams.get("id_event"));
    loadEventsInformations();
  }, [location.search, idEvent, id_association]);

  useEffect(() => {
    if (shift.length >= 1) {
      if (isEmpty(startDate) && !isEmpty(shift[0].start_datetime)) {
        setStartDate(shift[0].start_datetime);
      }
      if (isEmpty(endDate) && !isEmpty(shift[shift.length - 1].end_datetime)) {
        setEndDate(shift[shift.length - 1].end_datetime);
      }
    }
  }, [shift]);

  const handleAddTurno = () => {
    setShift([
      ...shift,
      {
        id: shift.length,
        id_shift: 0,
        title: "Turno " + (shift.length + 1),
        description: "",
        color: colors[0] ? colors[0] : "#000000",
        startDateTime: "",
        endDateTime: "",
        volunteers: 1,
        open_subscription: 0,
      },
    ]);
  };

  /*Rimozione di un turno */
  const handleRemoveTurno = (id) => {
    let isUpdate = false;
    shift.forEach((turno) => {
      if (turno.id === id && turno.id_shift) {
        isUpdate = true;
        return gestioneSnackbar(
          true,
          t("create_event.you_cannot_drop_this_shift"),
          "error"
        );
      }
    });

    if (!isUpdate) {
      setShift(shift.filter((turno) => turno.id !== id));
    }
  };

  /*Modifica dati dei turni */
  const handleInputChange = (id, field, value) => {
    setShift((prevTurni) =>
      prevTurni.map((turno) =>
        turno.id === id ? { ...turno, [field]: value } : turno
      )
    );
  };

  /*Inserimento di un giorno della settimana nella ripetizione della frequenza */
  const handleRepetitionDayOfWeek = (e, id) => {
    e.preventDefault();

    setSelectedDayRepetition((prev) => {
      if (prev.includes(id)) {
        // Rimuove l'ID se già presente
        return prev.filter((item) => item !== id);
      } else {
        // Aggiunge l'ID se non presente
        return [...prev, id];
      }
    });
  };

  /*Gestione delle immagini */
  const handleFileChange = (e) => {
    const max = 3;
    let files = Array.from(e.target.files).filter(
      (file) => file instanceof File
    );

    if (files.length === 0) {
      return;
    }

    if (images.length + files.length > max) {
      files = files.slice(0, max - images.length);
      gestioneSnackbar(true, t("create_event.error_number_image"), "error");
    }

    const newImageUrls = files.map((file) => URL.createObjectURL(file));

    setFiles((prevFiles) => [...prevFiles, ...files]);
    setImages((prevImages) => [...prevImages, ...newImageUrls]);
  };

  const handleRemoveImage = (index) => {
    const newImages = images.filter((_, i) => i !== index); // Rimuove l'immagine selezionata
    setImages(newImages);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isEmpty(name)) {
      gestioneSnackbar(true, t("create_event.mandatory_name"), "error");
      return;
    }
    if (isEmpty(indirizzo) || isEmpty(comune) || isEmpty(provincia)) {
      gestioneSnackbar(true, t("create_event.invalid_address"), "error");
      return;
    }

    if (isEmpty(startDate)) {
      gestioneSnackbar(true, t("create_event.invalid_start_date"), "error");
      return;
    }

    if (isEmpty(endDate)) {
      gestioneSnackbar(true, t("create_event.invalid_end_date"), "error");
      return;
    }

    if (moment(endDate).isBefore(moment(startDate))) {
      gestioneSnackbar(true, t("create_event.invalid_end_date_event"), "error");
      return;
    }

    //Se non ho turni mostro il modale di conferma
    if (!showModalShift && !thereAreShifts) {
      if (
        isEmpty(idEvent) &&
        shift.length === 1 &&
        isEmpty(shift[0].start_datetime) &&
        isEmpty(shift[0].end_datetime)
      ) {
        //creazione
        setShowModalShift(true);
        return;
      }
      if (!isEmpty(idEvent) && shift.length === 0) {
        //modifica
        setShowModalShift(true);
        return;
      }
    }

    if (showModalShift)
      // In questo caso ho premuto conferma del modale,
      // chiudo il modale e procedo con la creazione
      setShowModalShift(false);

    if (
      !showModalRepetition &&
      isEmpty(idEvent) &&
      thereAreRepetition &&
      selectedDayRepetition
    )
      return setShowModalRepetition(true);

    if (showModalRepetition)
      // In questo caso ho premuto conferma del modale,
      // chiudo il modale e procedo con la creazione
      setShowModalRepetition(false);

    let shifts = [];
    let counter = 1;
    console.log("Shift: " + shift);
    if (thereAreShifts) {
      for (const item of shift) {
        if (isEmpty(item.title)) {
          item.title = "Turno " + counter;
        }

        if (moment(item.end_datetime).isBefore(moment(item.start_datetime))) {
          gestioneSnackbar(
            true,
            t("create_event.invalid_end_date_shift"),
            "error"
          );
          return;
        } else {
          if (idEvent)
            shifts.push({
              id: item.id_shift ?? null,
              color: item.color,
              title: item.title,
              description: item.description,
              start_datetime: item.start_datetime,
              end_datetime: item.end_datetime,
              max_volunteer: item.max_volunteer,
              open_subscription: !!item.open_subscription,
            });
          else
            shifts.push({
              color: item.color,
              title: item.title,
              description: item.description,
              start_datetime: item.start_datetime,
              end_datetime: item.end_datetime,
              max_volunteer: item.max_volunteer,
              open_subscription: !!item.open_subscription,
            });
        }
        counter++;
      }
    }

    const body = {
      id_association,
      name,
      description,
      address: indirizzo + ", " + comune + ", " + daProvinciaASigla[provincia],
      start_date: moment(startDate, "YYYY-MM-DDTHH:mm").format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      end_date: moment(endDate, "YYYY-MM-DDTHH:mm").format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      public: publicEvent,
      topics: topic.toString(),
      event_types: eventType.toString(),
      shifts,
    };

    if (
      isEmpty(idEvent) &&
      thereAreRepetition &&
      !isEmpty(selectedDayRepetition)
    )
      body.day_repetition = selectedDayRepetition;

    const formData = new FormData();
    const filePromises = images.map(async (imageUrl, index) => {
      if (imageUrl.includes("http")) {
        const response = await fetch(imageUrl); // Ottieni il Blob
        const blob = await response.blob(); // Converti in Blob
        // Crea un file a partire dal Blob
        const file = new File([blob], `image_${index}.png`, {
          type: blob.type,
        });

        return file;
      } else {
        return base64ToBlob(imageUrl);
      }
    });
    // Attendi che tutti i Blob siano convertiti in File
    const filesBlob = await Promise.all(filePromises);
    filesBlob.forEach((file) => formData.append("photos", file));

    if (idEvent) {
      putEventWS({ body, formData, idEvent })
        .then((res) => {
          gestioneSnackbar(true, res, "success");
          navigate(`/dashboard/${id_association}/list-events`, {
            replace: true,
          });
        })
        .catch((err) => gestioneSnackbar(true, err.message, "error"));
    } else {
      postEventWS({ body, formData })
        .then((res) => {
          setName("");
          setDescription("");
          setIndirizzo("");
          setComune("");
          setProvincia("");
          setStartDate("");
          setEndDate("");
          setPublicEvent(false);
          setShift([
            {
              id: 0,
              id_shift: 0,
              color: "#000000",
              start_datetime: "",
              end_datetime: "",
              max_volunteer: 1,
            },
          ]);
          setTopic([]);
          setEventType([]);
          setImages([]);

          gestioneSnackbar(true, res, "success");
          navigate(`/dashboard/${id_association}/list-events`, {
            replace: true,
          });

          //Elimino lo URL creato per evitare perdite di prestazioni
          images.map((imageUrl) => URL.revokeObjectURL(imageUrl));
        })
        .catch((err) => gestioneSnackbar(true, err.message, "error"));
    }
  };

  return (
    <>
      <HeaderBar
        title={t(
          isEmpty(idEvent) ? "create_event.title" : "create_event.title2"
        )}
        back={true}
        path={"/dashboard/" + id_association}
      />
      <Form onSubmit={(e) => handleSubmit(e)}>
        <div className="create-event-container container-responsive ">
          <div className="input-container">
            <Form.Group className="mb-2" controlId="name">
              <Form.Label>{t("create_event.name_event")}</Form.Label>
              <Form.Control
                type="text"
                maxLength={40}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="input-container">
            <Form.Group className="mb-2" controlId="description">
              <Form.Label>{t("create_event.description_event")}</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                maxLength={1000}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="input-container">
            <div className="input-container">
              <Form.Group
                className="mb-2"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>{t("create_event.address")}</Form.Label>
                <Form.Control
                  type="text"
                  maxLength={150}
                  value={indirizzo}
                  onChange={(e) =>
                    setIndirizzo(e.target.value.replace(/,/g, ""))
                  }
                />
              </Form.Group>
              <Form.Group
                className="mb-2"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>{t("create_event.country")}</Form.Label>
                <Form.Control
                  type="text"
                  maxLength={60}
                  value={comune}
                  onChange={(e) => setComune(e.target.value)}
                />
              </Form.Group>
              <Form.Group
                className="mb-2"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>{t("create_event.provincia")}</Form.Label>
                <Form.Select
                  value={provincia}
                  onChange={(e) => setProvincia(e.target.value)}
                >
                  <option value="">{t("create_event.provincia")}</option>
                  {province.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>
          </div>
          <div className="input-container">
            <Form.Group>
              <Form.Label>{t("create_event.public")}</Form.Label>
              <Form.Select
                value={publicEvent}
                onChange={(e) => setPublicEvent(e.target.value)}
              >
                <option value={true}>{t("common.yes")}</option>
                <option value={false}>{t("common.no")}</option>
              </Form.Select>
            </Form.Group>
          </div>

          <hr />
          <div className="input-container mt-2">
            <Stack
              direction="horizontal"
              className="d-flex justify-content-between align-items-center "
            >
              <div>
                <b>{t("create_event.are_there_shift")}</b>
              </div>
              <div>
                <Form.Check // prettier-ignore
                  type="switch"
                  id="there-are-shifts-switch"
                  checked={thereAreShifts} // Imposta lo stato iniziale
                  onChange={(e) => setThereAreShifts(e.target.checked)} // Funzione di gestione del cambiamento
                />
              </div>
            </Stack>
          </div>

          {/*TURNII */}
          {thereAreShifts ? (
            <>
              {shift.map((turno, index) => (
                <div key={index} className="shift-input">
                  <div className="header-shift-container">
                    <h5>
                      {t("create_event.shift_number", { number: index + 1 })}
                    </h5>
                    <div>
                      <Button
                        variant="danger"
                        onClick={() => handleRemoveTurno(turno.id)}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  </div>
                  <div className="input-container">
                    <Form.Group
                      controlId={`volunteers-${index}`}
                      className="mb-2"
                    >
                      <Form.Label>{t("create_event.shift_title")}</Form.Label>
                      <Form.Control
                        type="text"
                        maxLength={50}
                        value={turno.title}
                        onChange={(e) =>
                          handleInputChange(index, "title", e.target.value)
                        }
                      />
                    </Form.Group>
                  </div>
                  <div className="input-container">
                    <Form.Group
                      controlId={`volunteers-${index}`}
                      className="mb-2"
                    >
                      <Form.Label>
                        {t("create_event.shift_description")}
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        maxLength={255}
                        value={turno.description}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "description",
                            e.target.value
                          )
                        }
                      />
                    </Form.Group>
                  </div>
                  <div className="input-container">
                    <Form.Group className="mb-2" controlId="formBasicEmail">
                      <Form.Label>{t("create_event.shift_color")}</Form.Label>
                      <ColorPicker
                        colors={colors}
                        onColorSelect={(selectedColor) =>
                          handleInputChange(index, "color", selectedColor)
                        }
                        selectedColor={turno.color}
                      />
                    </Form.Group>
                  </div>
                  <div className="input-container">
                    <Form.Group
                      controlId={`startDateTime-${index}`}
                      className="mb-2"
                    >
                      <Form.Label>
                        {t("create_event.shift_start_datetime")}
                      </Form.Label>
                      <Form.Control
                        type="datetime-local"
                        value={turno.start_datetime}
                        onChange={(e) => {
                          if (moment().isAfter(moment(e.target.value))) {
                            gestioneSnackbar(
                              true,
                              t("create_event.invalid_date"),
                              "error"
                            );
                            return;
                          }
                          handleInputChange(
                            index,
                            "start_datetime",
                            e.target.value
                          );

                          if (isEmpty(shift[index].end_datetime)) {
                            handleInputChange(
                              index,
                              "end_datetime",
                              moment(e.target.value)
                                .add(1, "hours")
                                .format("YYYY-MM-DD HH:mm:ss")
                            );
                          }
                        }}
                      />
                    </Form.Group>
                  </div>
                  <div className="input-container">
                    <Form.Group
                      controlId={`endDateTime-${index}`}
                      className="mb-2"
                    >
                      <Form.Label>
                        {t("create_event.shift_end_datetime")}
                      </Form.Label>
                      <Form.Control
                        type="datetime-local"
                        value={turno.end_datetime}
                        onChange={(e) => {
                          if (moment().isAfter(moment(e.target.value))) {
                            gestioneSnackbar(
                              true,
                              t("create_event.invalid_date"),
                              "error"
                            );
                            return;
                          }
                          handleInputChange(
                            index,
                            "end_datetime",
                            e.target.value
                          );
                        }}
                      />
                    </Form.Group>
                  </div>
                  <div className="input-container">
                    <Form.Group
                      controlId={`volunteers-${index}`}
                      className="mb-2"
                    >
                      <Form.Label>{t("create_event.max_volunteer")}</Form.Label>
                      <Form.Control
                        type="number"
                        value={turno.max_volunteer}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "max_volunteer",
                            e.target.value
                          )
                        }
                        min={1}
                      />
                    </Form.Group>
                  </div>
                  {publicEvent ? (
                    <div className="input-container">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="d-flex justify-content-between align-items-center "
                      >
                        <div>{t("create_event.open_subscription")}</div>
                        <div>
                          <Form.Check // prettier-ignore
                            type="switch"
                            id="there-are-shifts-switch"
                            checked={turno.open_subscription} // Imposta lo stato iniziale
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "open_subscription",
                                e.target.checked
                              )
                            } // Funzione di gestione del cambiamento
                          />
                        </div>
                      </Stack>
                    </div>
                  ) : null}
                </div>
              ))}
              <Button variant="info" className="mb-3" onClick={handleAddTurno}>
                {t("create_event.add_shift")}
              </Button>
            </>
          ) : null}
          <hr />

          <div className="input-container">
            <Form.Group className="mb-2" controlId="formBasicEmail">
              <Form.Label>{t("create_event.start_datetime")}</Form.Label>
              <Form.Control
                type="datetime-local"
                value={startDate}
                onChange={(e) => {
                  if (moment(e.target.value).isBefore(moment(), "day")) {
                    gestioneSnackbar(
                      true,
                      t("create_event.invalid_date"),
                      "error"
                    );
                    return;
                  }
                  setStartDate(e.target.value);
                }}
              />
            </Form.Group>
          </div>
          <div className="input-container">
            <Form.Group className="mb-2" controlId="formBasicEmail">
              <Form.Label>{t("create_event.end_datetime")}</Form.Label>
              <Form.Control
                type="datetime-local"
                value={endDate}
                onChange={(e) => {
                  if (moment(e.target.value).isBefore(moment(), "day")) {
                    gestioneSnackbar(
                      true,
                      t("create_event.invalid_date"),
                      "error"
                    );
                    return;
                  }
                  setEndDate(e.target.value);
                }}
              />
            </Form.Group>
          </div>

          {isEmpty(idEvent) ? (
            /**Check per la ripetizione dell'evento solo se sono in creazione */
            <div className="input-container mt-2">
              <Stack
                direction="horizontal"
                className="d-flex justify-content-between align-items-center "
              >
                <div>{t("create_event.repetition_check")}</div>
                <div>
                  <Form.Check // prettier-ignore
                    type="switch"
                    id="there-are-shifts-switch"
                    checked={thereAreRepetition} // Imposta lo stato iniziale
                    onChange={(e) => setThereAreRepetition(e.target.checked)} // Funzione di gestione del cambiamento
                  />
                </div>
              </Stack>
            </div>
          ) : null}

          {thereAreRepetition ? (
            <>
              <div className="input-container mt-2">
                {t("create_event.repetition_next_month", {
                  date: moment().add(1, "month").format("DD-MM-YYYY"),
                })}

                <Stack gap={2} className="frequence-day-repetition w-100 mt-1">
                  {[0, 1, 2, 3, 4, 5, 6].map((item) => (
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="p-2 day-of-week align-items-center"
                      style={{
                        borderBottom: item != 6 ? "1px solid #7f7f7f" : null,
                      }}
                      onClick={(e) => {
                        handleRepetitionDayOfWeek(e, item);
                      }}
                    >
                      {selectedDayRepetition.includes(item) ? (
                        <CheckRoundedIcon sx={{ width: 24, height: 24 }} />
                      ) : (
                        <div style={{ width: 24, height: 24 }}></div>
                      )}
                      <div>{giorniSettimana[item]}</div>
                    </Stack>
                  ))}
                </Stack>
              </div>
            </>
          ) : null}

          {!isEmpty(listTopic) ? (
            <ListTopic
              data={listTopic}
              title={t("create_event.choose_topic")}
              setSelected={setTopic}
              selected={topic}
              disabled={false}
            />
          ) : null}

          {!isEmpty(listEventType) ? (
            <ListEventType
              data={listEventType}
              title={t("create_event.choose_event_type")}
              setSelected={setEventType}
              selected={eventType}
              disabled={false}
            />
          ) : null}

          <div className="input-container">
            <Form.Group controlId="imageUploads">
              <Form.Label>{t("create_event.load_image")}</Form.Label>
              <Form.Control
                key={0} // Cambia la chiave per forzare un reset dell'input
                type="file"
                accept="image/*"
                multiple
                onChange={handleFileChange}
              />
              {images.length > 0 && (
                <div className="mt-3 selected-image">
                  {images.map((image, index) => (
                    <div key={index} className="selected-image-box">
                      <img src={image} alt={image.name} />
                      <Button
                        variant="ligth"
                        onClick={() => handleRemoveImage(index)}
                      >
                        <DeleteIcon size={20} />
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </Form.Group>
          </div>
          <div className="button-container">
            <Button variant="success" type="submit">
              {t("common.save")}
            </Button>
          </div>
          <VoidSpace />
        </div>
      </Form>

      {/* Modale di conferma se non ho turni */}
      <Modal
        show={showModalShift}
        onHide={() => setShowModalShift(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("create_event.shift_modal.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("create_event.shift_modal.body")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalShift(false)}>
            {t("common.cancel")}
          </Button>
          <Button variant="success" onClick={handleSubmit}>
            {t("common.confirm")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modale di conferma se ho delle ripetizioni */}
      <Modal
        show={showModalRepetition}
        onHide={() => setShowModalRepetition(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("create_event.repetition_modal.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("create_event.repetition_modal.body")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalShift(false)}>
            {t("common.cancel")}
          </Button>
          <Button variant="success" onClick={handleSubmit}>
            {t("common.confirm")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateEvent;
